import { IGetAnswersResponse } from '../../repositories/newbuilding-reviews/v1/get-answers';
import { IMappedAnswersResponse } from '../../types/answers';

export function prepareAnswers(response: IGetAnswersResponse, reviewId: string): IMappedAnswersResponse {
  const { answers, answerIds } = response.answers.reduce(
    (acc, answer) => {
      return {
        answers: {
          ...acc.answers,
          [answer.id]: { ...answer, reviewId },
        },
        answerIds: [...acc.answerIds, answer.id],
      };
    },
    { answers: {}, answerIds: [] },
  );

  return {
    ...response,
    answers,
    answerIds,
  };
}
